module.exports = __webpack_public_path__ + "img/ico_settings--wh.5f5893b8.svg";